import React, { useMemo, useState } from "react";
import { MainPageHeaderProps } from ".";
import { useTypedSelector } from "store";

import "./MainPageHeaderMobile.scss";
import BurgerMenu from "common/components/BurgerMenu";
import TopHeaderMobile from "./TopHeaderMobile";
import { showMobile } from "helpers/adaptation";
import { formatDate } from "../../../utils/formatDate";

const MainPageHeaderMobile = ({
  isPricingButtonHidden,
  isReloadLogo,
  type,
  showGameMenu,
  title,
  onLogin
}: MainPageHeaderProps) => {
  const { client }: any = useTypedSelector((store) => store.user);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="main-page-header-mobile">
        {showMobile && (
          <TopHeaderMobile
            {...{ isPricingButtonHidden, isReloadLogo }}
            onOpen={() => setIsOpen(!isOpen)}
            showGameMenu={showGameMenu}
            title={title}
            onLogin={onLogin}
          />
        )}
        {type === "main" && (
          <div className="bottom-header-mobile">
            <div className="item-bottom-header">
              <div>
                {!!client.firstName && (
                  <span>
                    שלום,
                    <strong>
                      {" "}
                      {client.firstName} {client.lastName}
                    </strong>
                  </span>
                )}
              </div>
              <div>
                {client.subscriptionValid && !!client.dateExpirde && (
                  <span>
                    תאריך תפוגה:
                    <strong>{formatDate(client.expired)}</strong>
                  </span>
                )}
              </div>
            </div>
            <div className="item-bottom-header">
              <div>
                <span>
                  סוג מנוי:{" "}
                  <strong>
                    {client.subscriptionValid ? client.subscriptionType : "מוגבל בתוכן"}
                  </strong>
                </span>
              </div>
              <div>
                {client.subscriptionValid && !!client.dateExpirde && (
                  <span>
                    ימים שנשארו:
                    <strong> {client.daysLeft}</strong>
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <BurgerMenu viewOpenLeftMenu={isOpen} handleClickCloseLeftMenu={() => setIsOpen(false)} />
    </>
  );
};

export default MainPageHeaderMobile;
